import React from 'react';
import cls from 'classnames';
import style from './Spinner.module.pcss';
import SvgSpinnerIcon from './Spinner.svg';

export interface Props {
  baseColor?: string;
  fillColor?: string;
  size?: string;
  className?: string;
  title?: string;
  testId?: string;
}

/**
 * Provide this component with a baseColor and a fillColor
 * The colors should be provided as the variable names found in partials/_colors.pcss
 * Example with black dots that gets filled with orange when animation runs:
 *  <SvgSpinner baseColor="hqvblack" fillColor="hqvorange" />
 */
const Spinner = ({
  baseColor = 'grey300',
  fillColor = 'orange500',
  size = '22px',
  className,
  title,
  testId,
}: Props) => {
  return (
    <span className={cls(style.Spinner, className)} title={title} data-testid={testId}>
      <SvgSpinnerIcon
        className={cls(style.spinner, `base:${baseColor} fill:${fillColor}`)}
        width={size}
        height={size}
      />
    </span>
  );
};

export default Spinner;
